
import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { selectActividadFromCurrentEmpresaByTipoActividad } from '../entity-actividades/entity-actividades.selectors';
import { entityLaboratoriosAdapter, EntityLaboratoriosState } from './laboratorios.state';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';

const { selectEntities, selectAll } = entityLaboratoriosAdapter.getSelectors();

export const getError = (state: EntityLaboratoriosState): any => state.error;

export const getIsLoading = (state: EntityLaboratoriosState): boolean =>
  state.isLoading;

export const getHasAddedSuccess = (state: EntityLaboratoriosState): boolean =>
  state.hasAddedSuccess;

export const selectLaboratoriosState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.laboratorios
);

export const selectAllLaboratorios = createSelector(selectLaboratoriosState, selectAll);
export const selectEntitiesLaboratorios = createSelector(
  selectLaboratoriosState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectLaboratoriosError = createSelector(
  selectLaboratoriosState,
  getError
);

// MemoizedSelector<object,any>
export const selectLaboratoriosIsLoading = createSelector(
  selectLaboratoriosState,
  getIsLoading
);

export const selectAllLaboratoriosFromCurrentEmpresa = createSelector(
  selectAllLaboratorios,
  selectCurrentEmpresa,
  (laboratorios, currentEmpresa) => {
    if (laboratorios && currentEmpresa){
      return laboratorios.filter((l) => l.entidad_productiva_id == currentEmpresa.id)
    } else {
      return []
    }
  }    
);

export const selectLaboratorioById = (laboratorioId: number) => createSelector(
  selectAllLaboratorios,  
  (laboratorios) =>
    laboratorios.find((l) => l.id == laboratorioId)
);

export const selectLaboratoriosAddedSuccess = createSelector(
  selectLaboratoriosState,
  getHasAddedSuccess
);